import React, { useContext,lazy,useEffect } from 'react';
import axios from 'axios';
import {Route, Switch} from "react-router-dom";
// import Categories from './../categories/categories';
import Register from './../register/Register';
import Brands from './../brands/Brands';
import CATEGORY_TWO from '../categories/Categories_Two';
import ProductsLev2 from './../categories/cat2Products/ProductsLev2'
import SearchProducts from './../search/SearchProducts';
import Preloader from './../Preloader/preloader';
import TahvilDate from './../SideBar/TahvilDate';
import Shops from '../products/Shops';
import Products from './../products/Products';
// import Home from './../FirstPage/Home';
import NotRegistered from './../register/NotRegistered';
import ProfileView from './../SideBar/ProfileView'
// import Tarh from './../Tarh/Tarh';
import TarhDarProducts from './../Tarh/TarhDars/TarhDarProducts';
import MyList from '../FirstPage/MyList';
import SabadKharidDrawer from './../products/SabadKharidDrawer/SabadKharidDrawer';
import TaeedShode from './../SideBar/Sefareshat/TaeedShode';
import SefareshatApi from '../SideBar/Sefareshat/SafareshatApi';
import SefareshatKFP from './../SideBar/Sefareshat/SefareshatKFP';
import NotFound from './NotFound';
import FreshShoped from './../Buy/FreshShoped';
import FreshProductsList from './../products/Fresh/FreshProductsList';
import FreshSearchProducts from './../search/FreshSearch/FreshSearchProducts';
import SimpleProduct from './../products/SimpleProduct/SimpleProduct';
import SingleProducts from './../products/SimpleProduct/SingleProducts';
import SingleProducts2 from './../products/SimpleProduct/SingleProducts2';
import SecondRegister from './../register/SecondRegister';
import Offers from './../FirstPage/banners/Offers';
import CustomerActs from './../FirstPage/CustomerActs';
import Rulls from './Rulls';
import Shop from '../Shops/Shop.jsx';
import SearchSortOrder from "../categories/SearchSortOrder";
import TarhDetails from "../Tarh/TarhDetails";
import UserClub from "../club/UserClub";
import Link from "./Link";
import SimpleContext from '../context/SimpleContext';
import UserPonits from "../ponis/UserPonits.jsx"
import CategoriesProducts from "../categories/CategoriesProducts";
import BrandsProducts from "../brands/BrandsProducts";
import ChatWithAdmin from "../SideBar/ChatWithAdmin";
import UserCode from "../register/UserCode";
import LoginWithCode from "../register/LoginWithCode";
import { Redirect } from 'react-router-dom';
import Savabegh from "../SideBar/Sefareshat/SafareshatApi";
import Product from '../products/Product';
import SafareshatDetailsKfp from "../SideBar/Sefareshat/SafareshatDetailsKfp";
import SafareshatDetailsApi from "../SideBar/Sefareshat/SafareshatDetailsApi";
import UserLocation from './UserLocation';
import AppPage from "../FirstPage/AppPage"
const Home = lazy(() => {
   return new Promise(resolve => setTimeout(resolve, 500)).then(() => import ('./../FirstPage/Home'));
 });

 const Tarh = lazy(() => {
   return new Promise(resolve => setTimeout(resolve, 500)).then(() => import ('./../Tarh/Tarh'));
 });
 const Categories = lazy(() => {
  return new Promise(resolve => setTimeout(resolve, 3000)).then(() => import ('./../categories/categories'));
 });
const TitleBox = () => {
   
   const context = useContext(SimpleContext)
   useEffect(() => {
      let myTime = Date.now();
      axios
        .get(`${context.baseUrlApiPakhsh}/api/timeMiliSecond`)
        .then((response) => {
          if (parseInt(response.data.code) === 200) {
            context.settimeMiliSecondDef(response.data.response - myTime);
          } else {
            console.log("1مشکلی در اتصال با سرور بوجود امده است");
          }
        })
        .catch((er) => {
          console.log(er);
          console.log("مشکلی در اتصال با سرور بوجود امده است");
        });
    },[]);
   
   return ( 
          
         <>
            <Switch>
               <>
               {
               // context.IsLoggedIn!==undefined&&
               <>
               <Route path="/register" exact component={Register}/>
               <Route path="/" exact>
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <AppPage/>}
               </Route> 
               <Route path="/homePage" exact>
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <Home/>}
               </Route> 
               <Route path="/userPonits" exact>
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <UserPonits/>}
               </Route> 
               <Route path={`/club/${context.MyId}`} exact>
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <UserClub/>}
               </Route> 
               <Route path="/link" exact>
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <Link/>}
               </Route> 
               <Route path="/secregister" exact>
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <SecondRegister/>}
               </Route> 
               <Route path="/Categories" exact>
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <Categories/>}
               </Route> 
               <Route path="/Brands"  exact>
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <Brands/>}
               </Route> 
               <Route path="/searchsortorder" exact>
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <SearchSortOrder/>}
               </Route> 
               <Route path="/Products" exact>
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <Products/>}
               </Route> 
               <Route path="/tarhha" exact >
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <Tarh/>}
               </Route> 
               <Route path="/loginWithCode" exact component={LoginWithCode}/>
               <Route path="/TarhDetails" exact>
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <TarhDetails/>}
               </Route> 
               <Route path="/CategoriesProducts" exact >
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <CategoriesProducts/>}
               </Route> 
               <Route path="/brandsProducts" exact>
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <BrandsProducts/>}
               </Route> 
               <Route path="/Buy" exact>
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <Shop/>}
               </Route> 
               <Route path="/userCode" exact component={UserCode}/>
               <Route path="/chatWithAdmin" exact>
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <ChatWithAdmin/>}
               </Route> 
               <Route path="/profileview" exact>
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <ProfileView/>}
               </Route> 
               <Route path="/CategoryLevTwo" exact >
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <CATEGORY_TWO/>}
               </Route> 
               <Route path="/CustomerActs" exact>
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <CustomerActs/>}
               </Route> 
               <Route path="/Shops" exact >
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <Shops/>}
               </Route> 
               <Route path="/ProductsLev2" exact >
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <ProductsLev2/>}
               </Route> 
               <Route path="/ُSearchResults" exact>
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <SearchProducts/>}
               </Route> 
               <Route path="/TarikhTahvil" exact >
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <TahvilDate/>}
               </Route> 
               <Route path="/savabegh" exact >
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <Savabegh/>}
               </Route> 
               <Route path="/sefareshatapi" exact >
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <SefareshatApi/>}
               </Route> 
               <Route path="/sefareshatKFP" exact >
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <SefareshatKFP/>}
               </Route> 
               <Route path="/notRegistered" exact >
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <NotRegistered/>}
               </Route> 
               <Route path="/tarhdarproducts" exact>
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <TarhDarProducts/>}
               </Route> 
               <Route path="/mylist" exact>
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <MyList/>}
               </Route> 
               <Route path="/Freshs" exact >
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <FreshProductsList/>}
               </Route> 
               <Route path="/sabadkhariddrawer" exact >
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <SabadKharidDrawer/>}
               </Route> 
               <Route path="/ُPreloader" exact component={Preloader} />
               
               <Route path="/freshshopped" exact >
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <FreshShoped/>}
               </Route> 
               <Route path="/userLocation" exact >
               <UserLocation/>
               </Route> 
               <Route path="/freshsearch" exact >
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <FreshSearchProducts/>}
               </Route> 
               <Route path="/simpleproduct" exact >
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <SimpleProduct/>}
               </Route> 
               <Route path="/singleproduct" exact >
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <SingleProducts/>}
               </Route> 
               <Route path="/singleproduct2" exact>
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <SingleProducts2/>}
               </Route> 
               <Route path="/offers" exact>
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <Offers/>}
               </Route>
               <Route path={`/product/${context.productRoight}`} exact> 
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <Product/>}
               </Route>
               <Route path="/detailsApi" exact>
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <SafareshatDetailsApi/>}
               </Route>
               <Route path="/detailsKfp" exact>
               {context.IsLoggedIn===false ? <Redirect to="/register" /> : <SafareshatDetailsKfp/>}
               </Route>
               <Route path="/rulls" exact component={Rulls}/>
             </>
             }
               </>
            </Switch>
         </>
   );
}

export default TitleBox;